
  import { FormsAndSurveyServices } from "@/services";
  import Vue from "vue";
  export default Vue.extend({
    data() {
      return {
        locationId: "",
        deletedForms: [],
        restoreInProgress: false,
        loadingForms: false,
        selected: [] as Array<{_id:string,name:string}>,
        fields: [{key:'selected',label:'Selected',class:'text-center'}, {key:'_id',label:'ID'},{key:'name',label:'Name'}],
      };
    },
    methods: {
      onRowSelected(items:Array<{_id:string,name:string}>) {
        this.selected = items
      },
      selectAllRows() {
        (this.$refs.selectableTable as unknown as { selectAllRows:Function }).selectAllRows()
      },
      clearSelected() {
        (this.$refs.selectableTable as unknown as { clearSelected:Function }).clearSelected()
      },
      async fetchAllDeletedForms() {
        try {
          if (!this.locationId) {
            throw new Error("locationId is required");
          }
          this.loadingForms = true;
          const { data } = await FormsAndSurveyServices.getDeletedFormsByLocation({
            locationId: this.locationId
          });
          this.deletedForms = data.forms;
          this.loadingForms = false;
        } catch (error) {
          console.log(error);
          this.deletedForms = []
          this.loadingForms = false;
        }
      },
      async restoreForms() {
        const app = this
        if(this.selected.length){
          try {
            this.restoreInProgress = true;
            await FormsAndSurveyServices.restoreFormsByIdAndName({ forms:this.selected.map(survey=>({id:survey._id,name:survey.name})) });
            await new Promise((res)=>{
              setTimeout(()=>{
                app.fetchAllDeletedForms();
                this.restoreInProgress = false;
                return res
              },3000)
            })
          } catch (error) {
            console.error(error);
            this.restoreInProgress = false;
          }
        }
      }
    }
  });
  